import React, { ReactElement } from 'react';

import Dropzone from 'react-dropzone';
import { BiImageAdd } from 'react-icons/bi';

import { DropContainer, UploadMessage } from './styles';

interface IUpload {
  onUpload: any;
}

const Upload: React.FC<IUpload> = ({ onUpload }) => {
  const renderDragMessage = (
    isDragActive: boolean,
    isDragReject: boolean,
  ): ReactElement<any, any> => {
    if (!isDragActive) {
      return <UploadMessage>Clique aqui para adicionar arquivos</UploadMessage>;
    }

    if (isDragReject) {
      return <UploadMessage type="error">Arquivo não suportado</UploadMessage>;
    }

    return <UploadMessage type="success">Solte os arquivos aqui</UploadMessage>;
  };

  return (
    <Dropzone onDropAccepted={onUpload}>
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <DropContainer
          {...getRootProps()}
          isDragActive={isDragActive}
          isDragReject={isDragReject}
        >
          <input {...getInputProps()} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '15px',
              gap: 5,
              flex: 1,
              color: '#329bfc',
            }}
          >
            <BiImageAdd size={30} />
            {renderDragMessage(isDragActive, isDragReject)}
          </div>
        </DropContainer>
      )}
    </Dropzone>
  );
};

export default Upload;
